import React from "react";
import { useNavigate } from "react-router-dom";

import EverestImg from "../../assets/optimized/everest.webp";
import LangtangImg from "../../assets/optimized/langtang3.webp";
import AnnapurnaImg from "../../assets/optimized/annapurna.webp";
import ManasluImg from "../../assets/optimized/manaslu.webp";
import EverestMobileImg from "../../assets/optimized/everest-mobile.webp";
import LangtangMobileImg from "../../assets/optimized/langtang3-mobile.webp";
import AnnapurnaMobileImg from "../../assets/optimized/annapurna-mobile.webp";
import ManasluMobileImg from "../../assets/optimized/manaslu-mobile.webp";
import ResponsiveImg from "../ui/ResponsiveImg";

const categories = [
  { id: 1, title: "Everest Region", region: "Khumbu", tag1: "High Altitude", img: EverestImg, mobileImg: EverestMobileImg },
  { id: 2, title: "Annapurna Circuit", region: "Central", tag1: "Cultural", img: AnnapurnaImg, mobileImg: AnnapurnaMobileImg },
  { id: 3, title: "Langtang Valley", region: "Helambu", tag1: "Alpine", img: LangtangImg, mobileImg: LangtangMobileImg },
  { id: 4, title: "Manaslu Circuit", region: "Gorkha", tag1: "Secluded", img: ManasluImg, mobileImg: ManasluMobileImg },
];

const QuickDiscovery = () => {
  const navigate = useNavigate();

  return (
    <section className="py-24 bg-[#F2F2F2] w-full px-6"> 
      <div className="max-w-7xl mx-auto">
        
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16 gap-6">
          <div>
            <h2 className="text-[#C99D89] uppercase tracking-[0.4em] text-[10px] font-bold mb-3">
              The Collection
            </h2>
            <h3 className="text-5xl md:text-6xl font-serif text-[#4A4E31] leading-tight">
              Signature Destinations
            </h3>
          </div>
          <button 
            onClick={() => navigate('/packages')}
            className="text-[10px] font-bold text-[#4A4E31] border-b border-[#4A4E31]/40 pb-1 hover:text-[#C99D89] hover:border-[#C99D89] transition-all tracking-[0.2em] uppercase"
          >
            View Full Map
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <div
              key={cat.id}
              onClick={() => navigate('/packages')}
              className="relative h-[550px] md:h-[650px] rounded-[32px] overflow-hidden group cursor-pointer shadow-lg"
            >
              <ResponsiveImg
                src={cat.img}
                mobileSrc={cat.mobileImg}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[2000ms] group-hover:scale-105"
                alt={cat.title}
                loading="lazy"
                decoding="async"
              />

              <div className="absolute top-6 left-6 z-10">
                <div className="bg-black/20 backdrop-blur-sm px-3 py-1 rounded-full border border-white/10">
                  <span className="text-white text-[8px] uppercase tracking-widest font-bold">
                    {cat.tag1}
                  </span>
                </div>
              </div>
              
              <div className="absolute inset-0 bg-gradient-to-t from-[#1a1c12] via-transparent to-transparent opacity-80" />              
              
              <div className="absolute bottom-10 left-8 right-8 z-10">
                <p className="text-[#C99D89] uppercase tracking-widest text-[9px] font-bold mb-2">
                  {cat.region}
                </p>
                <h4 className="text-white text-3xl font-serif leading-tight">
                  {cat.title}
                </h4>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickDiscovery;